import {
  Button, Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Paper,
  TextField as InputText,
  Typography
} from "@material-ui/core";
import {AttachmentOutlined, HelpOutline} from "@material-ui/icons";
import React, {useCallback, useEffect, useRef, useState} from "react";
import {useDataProvider, useNotify} from "react-admin";
import {useUploadHook} from "../../utils/upload.hook";
import formatStringByPattern from "format-string-by-pattern";


/**
 * @param {{
 *   form: any,
 *   onCancel: CallableFunction,
 *   onSubmit: CallableFunction,
 *   onAfterSubmit: CallableFunction,
 *   availabilityId: string,
 *   currentValues?: any,
 *   editMode?: string,
 *   requestId?: string,
 * }} props
 * @return {JSX.Element}
 * @constructor
 */
export function FormRequestFormComponent(props) {
	const [values, setValues] = useState(props.currentValues)
  const [showUseTermsModal, setShowUseTermsModal] = useState(props.editMode ? false : true);

	const dataProvider = useDataProvider()
	const {
    form,
    onCancel,
    onAfterSubmit,
    availabilityId ,
  } = props;

	const notify = useNotify();

  const changeValue = useCallback((label, value) => {
    setValues(prev => {
      return { ...prev, [label] : value }
    })
  }, [])

	const onSubmit = useCallback(async (values) => {
    const orderedValues = {}
    props.form.fields.forEach(field => orderedValues[field.label] = values[field.label] ?? '');

    if (props.editMode && props.requestId) {
      const result = await dataProvider.update('formsRequest/fields', {
        id: props.requestId,
        data: {
          fields: orderedValues,
          id: props.requestId,
          availabilityId
        },
      }).catch(err => {
        notify('Erro ao tentar cadastrar a solicitação', 'error')
      })
      if (result?.data) {
        notify('Solcitação Salva com Sucesso !')
        onAfterSubmit()
      }
    } else {

      const result = await dataProvider.create('formsRequest', {
        data: {
          fields: orderedValues,
          availabilityId
        },
      }).catch(err => {
        notify('Erro ao tentar cadastrar a solicitação', 'error')
      })
      if (result?.data) {
        notify('Solcitação Registrada com Sucesso !')
        onAfterSubmit()
      }
    }
	}, [dataProvider, onAfterSubmit, availabilityId, notify])

	return (
		<Paper style={{ padding: 20 }}>
			<Typography variant={'h4'}>
				{form?.name}
			</Typography>
			<Typography variant={'h6'}>
				{form?.description}
			</Typography>
      {
        props.form.showUseTerms && (
          <div style={{width: '100%', display: 'flex', justifyContent: 'flex-end'}}>
            <Button
              onClick={() => setShowUseTermsModal(true)}
              startIcon={<HelpOutline/>}
            >
              Instruções de Preenchimento
            </Button>
          </div>
        )
      }
      {
        form.attachment?.length > 0 && form.attachment.map(att => (
          <div style={{width: '100%'}}>
            <a href={att.path} target={'_blank'} rel="noreferrer">
              <Button startIcon={<AttachmentOutlined/>} variant={'text'} color={'primary'}>
                {att?.name}
							</Button>
						</a>
					</div>
				))
			}
			<br />
			<br />
			<div style={{ paddingTop: 10 }}>
				<form onSubmit={evt => {
					evt.preventDefault()
					onSubmit(values)
				}}>
					<div style={{ display: 'flex', gap: 20, flexDirection: 'column' }}>
						{
							form.fields.map(field => (
								<FormField
									field={field}
                  changeValue={changeValue}
                  value={values ? values[field.label] : null}
								/>
							))
						}
					</div>
          {
            props.form.showUseTerms && showUseTermsModal && (
              <UseTermsDialog
                onClose={() => setShowUseTermsModal(false)}
                open={true}
                useTerms={props.form.useTerms}
              />
            )
          }
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: 20}}>
            <Button type={'submit'} variant={'contained'}>Registrar</Button>
            <Button onClick={onCancel}>Cancelar</Button>
          </div>
        </form>
      </div>
    </Paper>
  )
}

function FormField(props) {
  const {field, value } = props;

  switch (field.type) {
    case 'file':
      return  (
        <UploadInput
          field={field}
          value={value}
          onChange={values => props.changeValue(field.label, values)}
        />
      )
    case 'number':
      return (
        <InputText
          label={field.label}
          name={field.label}
          required
          pattern={'[1-9]'}
          htmlType={'number'}
          variant={'outlined'}
          fullWidth
          onChange={evt => props.changeValue(field.label, evt.target.value)}
        />
      )
    default:

      return  (
        <InputText
          multiline
          label={field.label}
          name={field.label}
          required
          value={value}
          onInput={evt => {
            if (field.mask) {
              if (field.mask.includes('9')) {

              }
              evt.target.value = formatStringByPattern(field.mask, evt.target.value.replace(/[^\d]/g, ""))
            }

          }}
          htmlType={'number'}
          variant={'outlined'}
          fullWidth
          onChange={evt => props.changeValue(field.label, evt.target.value)}
        />
      )
  }
}

function UploadInput(props) {
	const [files, setFiles] = useState(Array.isArray(props.value) ? props.value : []);
	const [loading, setLoading] = useState(false)
  const inputFileRef = useRef(null);
	const { uploadFile } = useUploadHook()
	const { onChange } = props

	const onChangeFile = useCallback((evt) => {
    setLoading(true)
    const files = []
    for (const file of evt.target.files) {
      files.push(file);
    }
    return Promise.allSettled(
      files.map(
        file => {
          return uploadFile(file, 'formsRequest').then(f => {
            setFiles(prev => [...prev, f[0]])
          })
        }
      )
    ).finally(() => {
			setLoading(false)
		});
	}, [uploadFile])

  useEffect(() => {
    onChange(files)
  }, [files]);

	return (
		<>
			<label
        onClick={() => inputFileRef.current?.click()}
				style={{
					cursor: 'pointer',
					padding: 15,
					borderRadius: 5,
					background: '#1f1f1f',
					fontFamily: 'Roboto',
					textAlign: 'center'
				}}
			>
				{props.field.label}
				<br />
				{loading && 'Fazendo o upload. Aguardo um instante...'}
			</label>
			{files?.map(file => (
          <div
            style={{zIndex: 10}}
            onClick={evt => {
              evt.stopPropagation()
            }}
          >
            <Chip
              key={file.name}
              label={file.name}
              onDelete={(evt) => {
                setFiles(prev => prev.filter(w => w?.name !== file.name))
              }}
              onClick={evt => evt.stopPropagation()}
            />
          </div>
      ))}
      <input
        ref={inputFileRef}
        onChange={onChangeFile}
        id={`file-upload-field-${btoa(props.field.name)}`}
        name={`file-upload-field-${btoa(props.field.name)}`}
        multiple
        type={'file'}
        accept=".png,.jpeg,.jpg,.pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        style={{display: 'none'}}
      />
    </>
  )
}

const UseTermsDialog = ({ open, onClose, useTerms }) => {
  const [accept, setAccept] = useState(false);
  return (
    <Dialog open={open} fullWidth maxWidth={'lg'}>
      <DialogTitle> Instruções de Preenchimento </DialogTitle>
      <DialogContent dividers>
        <DialogContentText style={{whiteSpace: 'pre-line'}}>
          {useTerms}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-start', fontFamily: 'Roboto'}}>
          <div>
            <Checkbox onChange={e => setAccept(e.target.checked)}  />
            Declaro que li e compreendi todas as instruções de preenchimento do formulário. &nbsp;
          </div>

          <Button disabled={!accept} variant='contained' onClick={onClose}>Fechar</Button>
        </div>

      </DialogActions>
    </Dialog>
  )
}
